import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BaseSiteService, CmsService, OccConfig, OccEndpointsService, UserIdService } from '@spartacus/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { CommonApiService } from '../../spartacus/services/common-api.service';
import { StartOrderService } from '../../custom-start-order/start-order.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
    selector: 'app-popupdashboard',
    templateUrl: './popupdashboard.component.html',
    styleUrls: ['./popupdashboard.component.scss'],
    standalone: false
})
export class PopupdashboardComponent {
  popupsData: any;
  creditBlockModal: boolean=false;
  customerRegion: boolean=true;
  showConsentPopup: boolean = false;
  creditPopUpData: any="";
  autoRolloverPopUpData: any="";
  ukConsentPopupData: any="";
  marketingEmail: any;
  showApiFailurePopup: boolean=false;
  apiFailurePopupData: any="";
  showReturnsSecPopup: boolean=false;
  returnsSecPopupData: any="";
  returnsFirstPopupData: any="";
  showReturnsFirstPopup: boolean=false;
  showUSConsentPopup: boolean=false;
  usConsentPopupData: any;
  isApiFailurePopupEnable: boolean=false;
  isAsmUser: boolean = false;
  rbavalue: any;
  isSearchByProfile: boolean=false;
  ArrPopUpModal: boolean=false;
  termsAccepted: boolean = false;
  // marketingConsent: 'true' | 'false' | null = null;
  @Input() popuptype:string=''
  constructor(private router: Router,private baseSiteService:BaseSiteService,private component: CmsService,private userInfoService: UserInfoService,private startOrderService:StartOrderService,
    private occEndpointsService:OccEndpointsService,private commonService:CommonApiService,private userIdService: UserIdService,private gtmService:GoogleTagManagerService,private cdr:ChangeDetectorRef,protected config: OccConfig) {
    
  }
  closeCreditPopUp(){
    this.creditBlockModal=false;
    
  }
 closeReturnsSecPopup(){
  this.showReturnsSecPopup=false;
  sessionStorage.setItem('returnsSecondPopup','false');
 }
 closeReturnsFirstPopup(){
  this.showReturnsFirstPopup=false;
  sessionStorage.setItem('returnsFirstPopup','false');
 }
 closeUkConsentPopup(){
   this.showConsentPopup=false;
   document.body.style.overflow = 'auto';
 }
  // for auto rollover popup when user checks the box
  sendAutoRollOverStatus() {
    //for backend we are sending the status as true when user checks the box so that for the season the popup should be disabled
    this.userInfoService.sendARRPopUpStatus(true).subscribe({
        next: (response) => {
        this.ArrPopUpModal = false;
        this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error updating rollover status:', error);
        }
      }); 
  }

  closeAutoRolloverPopUp(type:String){
    //once the popup is closed, to enable the scroll in body
    // const body = document.querySelector('body') as HTMLElement;
    // if(body) {
    //   body.style.overflowY = 'auto';
    // }
    const gtmData = {
        event: 'modal_interaction',
        interaction_type:type,
        checkbox_state:this.termsAccepted?'selected':'not_selected'
    };
    this.gtmService.pushTag(gtmData)
    
    //if user chooses the checkbox then we are calling the sendAutoRollOverStatus method to update the status
    if(this.termsAccepted){
      this.sendAutoRollOverStatus();
    }
    //other wise the popup will be closed for the session and the popup will be displayed again when the user logs in next time
    else{
      this.ArrPopUpModal = false;
      sessionStorage.setItem('ARRPopUpStatus', 'false');
    }
  }

  signUpForAutoRollover() {
    //once the popup is closed, to enable the scroll in body
    // const body = document.querySelector('body') as HTMLElement;
    // if (body) {
    //   body.style.overflowY = 'auto';
    // }
    const gtmData = {
      event: 'modal_interaction',
      interaction_type:'signup',
      checkbox_state:this.termsAccepted?'selected':'not_selected'
    };
    this.gtmService.pushTag(gtmData);
    
    //if user chooses the checkbox then we are calling the sendAutoRollOverStatus method to update the status and to close the popup even if we are navigating back to myaccount page
    if (this.termsAccepted) {
      this.sendAutoRollOverStatus();
      sessionStorage.setItem('ARRPopUpStatus', 'false'); 
    }
    //otherwise just for the session we are closing the popup even if the user is navigating back to myaccount page again
    else{
      sessionStorage.setItem('ARRPopUpStatus', 'false');
    }
  }
//to capture the marketing consent change
//   confirmConsent(): void {
//    if (this.marketingConsent !== null) {
//      this.isConsentGranted(this.marketingConsent);
//    }    
//  }
  isConsentGranted(text:string){
    let userId =this.commonService.userId;
    this.userIdService.getUserId().subscribe(item => {
      if(item)
        userId = item;
    });
    let endpoint = this.occEndpointsService.buildUrl(`/users/${userId}/my-profile/marketingconsent/${text}`);
    let payload: any = {
      url: endpoint,
    }
    this.commonService.postAPICall(payload).subscribe(res => {
      if(this.showConsentPopup){
        this.showConsentPopup = false;
        document.body.style.overflow = 'auto';
      }
      if(this.showUSConsentPopup)
        this.showUSConsentPopup=false;
      this.cdr.detectChanges();

    });
  }

  ngOnInit(){
    
    this.rbavalue=localStorage.getItem('rbapermission');
    this.rbavalue=JSON.parse(this.rbavalue);
    this.cdr.detectChanges(); 

    this.userInfoService.getswitchrba().subscribe(value => {
      if(value){
        this.rbavalue=value;
        this.cdr.detectChanges();
      }
    });

    this.userInfoService.checkCustomerRegion().subscribe(value => {
      if(value){
        this.customerRegion=value;
        this.cdr.detectChanges();
      }
    });

  if(this.popuptype != 'apierror'){
    this.userInfoService.dashboardOrderData$.subscribe((data) => {
      if(data){
      data.subscribe((dta:any) => {
        this.popupsData = dta;
        if(this.popupsData.creditBlockPopup == true){
          this.creditBlockModal = true;
          this.component.getComponentData('creditsPopup').subscribe((data)=>{
            this.creditPopUpData = data;
            this.cdr.detectChanges();
          });
          
        }
        //the popup will be displayed only if the displayARRPopup is true and when the session storage for ARRPopUpStatus is true
        if(this.popupsData.displayARRPopup == true && sessionStorage.getItem('ARRPopUpStatus') != 'false'){
          this.ArrPopUpModal = true;

          //gtm changes
          const gtmData = {
            event: 'modal_interaction',
            interaction_type:'served'
        };
         this.gtmService.pushTag(gtmData)
          //when the popup is openend to remove the scroll from body
          // const body = document.querySelector('body') as HTMLElement;
          // if (body) {
          //     body.style.overflowY = 'hidden';
          // }
          //getting the data from the componnet
          this.component.getComponentData('autoRolloverPopup').subscribe((data)=>{
            this.autoRolloverPopUpData = data;
            this.cdr.detectChanges();
          });          
        }

        if(this.popupsData.isConsentDisplay == false){
          this.baseSiteService.getActive().subscribe(site => {
            if(site == 'seqirusb2b-flu360'){
              this.showUSConsentPopup = true;
              this.marketingEmail = this.popupsData.marketingEmailId;
              this.component.getComponentData('consent-popup-Component').subscribe((data)=>{
                this.usConsentPopupData = data;
                this.cdr.detectChanges();
              });

            }
            else if(site == 'seqirusb2b-uk' && !this.isAsmUser){
              this.showConsentPopup = true;
              document.body.style.overflow = 'hidden';
              this.marketingEmail = this.popupsData.marketingEmailId;
              this.component.getComponentData('ukMarketingPopup').subscribe((data)=>{
                this.ukConsentPopupData = data;
                this.cdr.detectChanges();
              });
            }
            else if(site == 'seqirusb2b-uk' && this.isAsmUser){
              this.showConsentPopup = true;
              this.marketingEmail = this.popupsData.marketingEmailId;
              this.component.getComponentData('ukMarketingPopup').subscribe((data)=>{
                this.ukConsentPopupData = data;
                this.cdr.detectChanges();
              });
            }
          })
          
        }
        
        this.component.getComponentData('apiFailurePopup').subscribe((data)=>{
            this.apiFailurePopupData = data;
            this.cdr.detectChanges();
        });
        
        if(sessionStorage.getItem('returnsFirstPopup') != 'false'){
        if((this.rbavalue?.RBAPermissions==false && this.popupsData.returnsFirstPopupShow == true) || (this.rbavalue?.RBAPermissions==true && this.rbavalue?.showDashboardOrderUK==true && this.popupsData.returnsFirstPopupShow == true)){
          this.showReturnsFirstPopup = true;
          this.component.getComponentData('returnsPopupfirst').subscribe((data)=>{
            this.returnsFirstPopupData = data;
            this.cdr.detectChanges();
          });
        }
        }
        
        if(sessionStorage.getItem('returnsSecondPopup') != 'false'){
          if((this.rbavalue?.RBAPermissions==false && this.popupsData.returnsSecondPopupShow == true) || (this.rbavalue?.RBAPermissions==true && this.rbavalue?.showDashboardOrderUK==true && this.popupsData.returnsSecondPopupShow == true)){
              
          this.showReturnsSecPopup = true;
          this.component.getComponentData('returnsPopupSecond').subscribe((data)=>{
            this.returnsSecPopupData = data;
            this.cdr.detectChanges();
          });
          }
        }
      })
    }
  
    })
  }
  //Commented as global error Popup implemented
    /* this.startOrderService.getApiFailurePopup().subscribe(value => {
      if(value){
        this.showApiFailurePopup=true;
        this.component.getComponentData('apiFailurePopup').subscribe((data)=>{
          this.apiFailurePopupData = data;
          this.cdr.detectChanges();
        });
      }
      this.cdr.detectChanges();
    }) */

    this.isAsmUser = this.userInfoService.checkAsmUser();
    this.isSearchByProfile = localStorage.getItem('isSearchByProfile') == 'false' ? false:true;
  }

  ngAfterViewInit(){
    
  }

  closeApifailurePopup(){
    this.startOrderService.setApiFailurePopup(false);
    this.router.navigate(['/my-account']);
  }

  sendNotShowFirstPopup(){
    this.userInfoService.sendReturnsPopupNotShow('false','').subscribe(data => {
      this.showReturnsFirstPopup=false;
      this.cdr.detectChanges();
    });
  }
  sendNotShowSecPopup(){
    this.userInfoService.sendReturnsPopupNotShow('','false').subscribe(data => {
      this.showReturnsSecPopup=false;
      this.cdr.detectChanges();
    });
  }
  getImage(image: any){
   return this.config.backend?.occ?.baseUrl + image.url;
  }
}
